export class Contract {
  salesHubContractNumber: string;
  salesHubContractUrl: string;
  contractRecordType: string;
  contractDocumentStatus: string;
  contractState: string;
  ipContractNumber: number;
  ipContractStatusName: string;

  public static fromJson(contractJson: any) {
    return Object.assign(new Contract(), contractJson);
  }
}
